import { Component, Vue, Ref, Prop, Inject} from 'vue-property-decorator'
@Component({
  name: 'widgetCommon'
})
export default class extends Vue {
  public showPicker = false
  public changeStatus (type) {
    this.showPicker = type
  }
}
